import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/proyectos_operaciones/proyectos_operaciones';
import Listar from './Listar';


const ms2p = (state) => {
  return {
    ...state.proyectos_operaciones,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Listar);
